/* eslint-disable max-len */
import React from 'react';

const GooglePlus = () => (
  <svg
    width="23"
    height="22"
    viewBox="0 0 23 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.6352 9.54375H13.5745H11.4419H7.89242V11.5954H11.3325C10.8352 13.0646 9.46394 14.1204 7.84949 14.1204C5.81487 14.1204 4.166 12.444 4.166 10.376C4.166 8.30917 5.81487 6.63296 7.84949 6.63296C8.74085 6.63296 9.55567 6.95572 10.1927 7.4907H10.2889L11.8043 5.95057C10.7595 4.98793 9.37282 4.4003 7.84949 4.4003C4.60054 4.4003 1.96655 7.07702 1.96655 10.376C1.96655 13.6784 4.60054 16.3531 7.84949 16.3531C8.27472 16.3531 8.70076 16.3081 9.11525 16.2142C9.95802 16.0289 10.7534 15.648 11.4334 15.1173C12.1095 14.5898 12.6665 13.9127 13.061 13.1527C13.2612 12.7623 13.42 12.3523 13.5316 11.9299C13.6468 11.4908 13.642 11.0493 13.6372 10.6004C13.6362 10.5098 13.6352 10.419 13.6352 10.3278V9.54375ZM17.2715 12.9342H18.9949V11.2211H20.7084V9.49876H18.9949V7.7849H17.2715V9.49876H15.5593V11.2211H17.2715V12.9342Z"
      fill="black"
    />
  </svg>
);

export default GooglePlus;
